import { render, staticRenderFns } from "./WaitingConfirm.vue?vue&type=template&id=3d45949a&"
import script from "./WaitingConfirm.vue?vue&type=script&lang=js&"
export * from "./WaitingConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports